import { useTranslation } from 'react-i18next';

import { DataItem } from '@/ui';
import type { PermanentResidence } from '@/signalr';
import { formatCoordinates, formatCoordinatesToDegree } from '@ngsos/portal-core/incidents';
import { MarkerHeader } from './MarkerHeader';

export type CallerPermanentResidenceMarkerDetailTemplateProps = {
  item?: PermanentResidence | null;
};

export function CallerPermanentResidenceMarkerDetailTemplate({
  item,
}: CallerPermanentResidenceMarkerDetailTemplateProps) {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column gap-2">
      <MarkerHeader
        title={t('Incident_PermanentResidenceMarker_PermanentResidence')}
        iconUrl="/Images/Icons/map-home.svg"
      />

      <DataItem title={t('Incident_PermanentResidenceMarker_Address')}>
        <div className="medium">
          <div>{item?.fullAddress}</div>
          <div>{item?.hint}</div>
        </div>
      </DataItem>
      <DataItem
        title={t('Incident_PermanentResidenceMarker_Coordinates')}
        value={formatCoordinatesToDegree(item?.coordinates)}
        allowCopyToClipboard
        valueToCopy={formatCoordinates(item?.coordinates)}
      />
    </div>
  );
}
